// Do not modify directly
// Generated from file: learnin.core.application/Persistence/UserRequestApprovalRepository/Queries/RequestApprovalType.cs

enum RequestApprovalType {
  Program,
  Resource,
}

export default RequestApprovalType;
